<template>
  <div class="container">
    <div class="main-card">
      <div class="header-section">
        <h1 class="main-title">Sistema di Fatturazione</h1>
        <p class="subtitle">Seleziona il tipo di operazione da eseguire</p>
      </div>

      <div class="actions-grid" :class="{ 'actions-grid--single': isBackofficeOnlyView || isAssistenzaExtraOnly }">
        <div v-if="canSeeStandardFatturazioneCards" class="action-card" @click="navigateToPower">
          <div class="card-icon power-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
          <h3 class="card-title-fatture">Fatturazione Power</h3>
          <p class="card-description">Gestisci le fatture di energia elettrica</p>
          <div class="card-arrow">→</div>
        </div>

        <div v-if="canSeeStandardFatturazioneCards" class="action-card" @click="navigateToGas">
          <div class="card-icon gas-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14,2 14,8 20,8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10,9 9,9 8,9" />
            </svg>
          </div>
          <h3 class="card-title-fatture">Fatturazione Gas</h3>
          <p class="card-description">Gestisci le fatture del gas naturale</p>
          <div class="card-arrow">→</div>
        </div>

        <div v-if="canSeeStandardFatturazioneCards" class="action-card" @click="navigateToCheckNonFatturati">
          <div class="card-icon check-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 11l3 3l8-8" />
              <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9s4.03-9 9-9c1.22 0 2.38.24 3.44.68" />
            </svg>
          </div>
          <h3 class="card-title-fatture">Check Non Fatturati</h3>
          <p class="card-description">Controlla gli elementi non ancora fatturati</p>
          <div class="card-arrow">→</div>
        </div>

        <div v-if="canSeeValidazioneFattureCard" class="action-card validate-card" @click="navigateToValidazioneFatture">
          <div class="card-icon validate-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14,2 14,8 20,8" />
              <path d="m9 15 2 2 4-4" />
            </svg>
          </div>
          <h3 class="card-title-fatture">Validazione Fatture</h3>
          <p class="card-description">Valida e approva le fatture generate</p>
          <div class="card-arrow">→</div>
        </div>

        <div v-if="hasAllProfile" class="action-card info-card" @click="navigateToInfoFatturazione">
          <div class="card-icon info-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 16v-4" />
              <path d="M12 8h.01" />
            </svg>
          </div>
          <h3 class="card-title-fatture">Info Fatturazione</h3>
          <p class="card-description">Informazioni e statistiche sulla fatturazione</p>
          <div class="card-arrow">→</div>
        </div>
        <div v-if="canSeeFattureExtraCard" class="action-card extra-card" @click="navigateToFatturazioneExtra">
          <div class="card-icon extra-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M8 12h8M12 8v8" />
            </svg>
          </div>
          <h3 class="card-title-fatture">Fatturazione Extra</h3>
          <p class="card-description">Creazione Fatture extra</p>
          <div class="card-arrow">→</div>
        </div>
        <div v-if="canSeeStandardFatturazioneCards" class="action-card depositi-card" @click="navigateToGestioneDepositi">
          <div class="card-icon depositi-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="10" width="18" height="10" rx="2" />
              <path d="M7 10V7a5 5 0 0 1 10 0v3" />
              <path d="M12 14v3" />
              <path d="M10 16h4" />
            </svg>
          </div>
          <h3 class="card-title-fatture">Gestione Depositi</h3>
          <p class="card-description">Gestisci i depositi dei clienti</p>
          <div class="card-arrow">→</div>
        </div>
      </div>

      <div class="footer-section">
        <div class="info-banner">
          <p>💡 Seleziona un'operazione per iniziare il processo di fatturazione</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FatturazioneView',
  computed: {
    userProfile() {
      try {
        const userLoggedStorage = localStorage.getItem('user')
        if (!userLoggedStorage) return null

        const decodedUser = JSON.parse(atob(userLoggedStorage))
        return decodedUser.user[0].profile || null
      } catch (error) {
        console.error('Errore nel controllo del profilo:', error)
        return null
      }
    },
    hasAllProfile() {
      const userProfile = this.userProfile
      return userProfile && (userProfile.all === 1 || userProfile.all === 4)
    },
    canSeeStandardFatturazioneCards() {
      return this.hasActiveProfile(['all', 'contabilita', 'credito'])
    },
    canSeeFattureExtraCard() {
      return this.canSeeStandardFatturazioneCards || this.hasActiveProfile(['assistenza_clienti'])
    },
    canSeeValidazioneFattureCard() {
      return this.hasActiveProfile(['all', 'contabilita', 'credito', 'fatturazione_light', 'backoffice'])
    },
    isAssistenzaExtraOnly() {
      return this.canSeeFattureExtraCard && !this.canSeeStandardFatturazioneCards && !this.canSeeValidazioneFattureCard && !this.hasAllProfile
    },
    isBackofficeOnlyView() {
      return this.hasActiveProfile(['backoffice'])
        && !this.canSeeStandardFatturazioneCards
    },
  },
  methods: {
    hasActiveProfile(profiles) {
      const userProfile = this.userProfile
      if (!userProfile) return false

      return profiles.some((profile) => profile in userProfile && userProfile[profile] == 1)
    },
    navigateToPower() {
      window.location.href = '/fatturazione';
    },

    navigateToGas() {
      window.location.href = '/fatturazionegas';
    },

    navigateToCheckNonFatturati() {
      window.location.href = '/checknonfatturati';
    },

    navigateToValidazioneFatture() {
      window.location.href = '/Validazionefatture';
    },

    navigateToInfoFatturazione() {
      window.location.href = '/InfoFatturazione';
    },
    navigateToFatturazioneExtra() {
      window.location.href = '/FatturazioneExtra';
    },
    navigateToGestioneDepositi() {
      window.location.href = '/GestioneDepositi';
    }
  }
}
</script>

<style scoped>
.container {
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
}

.header-section {
  text-align: center;
  margin-bottom: 3rem;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.5rem 0;
  background: #0d3c61;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.subtitle {
  font-size: 1.1rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-bottom: 2rem;
}

.actions-grid--single {
  grid-template-columns: minmax(280px, 420px);
  justify-content: center;
}

.action-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.action-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border-color: transparent;
}

.action-card:nth-child(1):hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.action-card:nth-child(2):hover {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
}

.action-card:nth-child(3):hover {
  background: linear-gradient(135deg, #ff6b6b 0%, #ffa726 100%);
  color: white;
}

.validate-card:hover {
  background: linear-gradient(135deg, #0d3c61, #215159, #3288b3);
  color: white;
}

.info-card:hover {
  background: linear-gradient(135deg, #23cdf3 0%, #92e9f4 100%);
  color: white;
}

.extra-card:hover {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  color: white;
}

.depositi-card:hover {
  background: linear-gradient(135deg, #f6d365, #fda085);
  color: white;
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  transition: all 0.3s ease;
}

.power-icon {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.gas-icon {
  background: linear-gradient(135deg, #11998e, #38ef7d);
  color: white;
}

.check-icon {
  background: linear-gradient(135deg, #ff6b6b, #ffa726);
  color: white;
}

.validate-icon {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  color: white;
}

.info-icon {
  background: linear-gradient(135deg, #23cdf3 0%, #92e9f4 100%);
  color: white;
}

.extra-icon {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  color: white;
}

.depositi-icon {
  background: linear-gradient(135deg, #f6d365, #fda085);
  color: white;
}

.action-card:hover .card-icon {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #1a202c;
  background-color: none !important;
  transition: color 0.3s ease;
  font-family: 'Montserrat', sans-serif !important;
}

.card-description {
  font-size: 0.95rem;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
  font-family: 'Montserrat', sans-serif !important;
  transition: color 0.3s ease;
}

.action-card:hover .card-title,
.action-card:hover .card-description {
  color: white;
}

.card-arrow {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 1.5rem;
  font-weight: bold;
  opacity: 0;
  transition: all 0.3s ease;
  color: white;
}

.action-card:hover .card-arrow {
  opacity: 1;
  transform: translateX(5px);
}

.footer-section {
  margin-top: 2rem;
}

.info-banner {
  background: linear-gradient(135deg, #e0e7ff, #f0f9ff);
  border: 1px solid #c7d2fe;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  text-align: center;
}

.info-banner p {
  margin: 0;
  color: #3730a3;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    padding: 1rem;
  }

  .main-card {
    padding: 2rem;
  }

  .main-title {
    font-size: 2rem;
  }

  .actions-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .action-card {
    min-height: 140px;
    padding: 1.5rem;
  }

  .card-icon {
    width: 50px;
    height: 50px;
  }

  .card-title {
    font-size: 1.1rem;
  }

  .card-description {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .main-card {
    padding: 1.5rem;
    border-radius: 16px;
  }

  .main-title {
    font-size: 1.75rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .action-card {
    min-height: 120px;
    padding: 1.25rem;
  }
}
</style>